import { getDeep } from '@shared/utils/getDeep.js';
import { setDeep } from '@shared/utils/setDeep.js';
import { store } from '../../../../redux/lib/configureStore';
import { action } from '@/lib/api.js';
import pushChangesQueueItem from '@/redux/actions/pushChangesQueueItem.js';

const projectIssueActions = {
  set(path, payload, opts) {
    return new Promise((resolve) => {
      if (!opts?.issueId) {
        console.error('Issue ID is required');
        return;
      }

      const state = store.getState();
      const issues = state?.settings?.projectIssues || [];
      const issue = issues.find((i) => i.id === opts.issueId);

      const newIssue = setDeep(issue, path, payload);
      const value = getDeep(path, newIssue);

      action('PUT_PROJECT_ISSUE', { data: [newIssue] });
      pushChangesQueueItem('projectIssue', { issueId: opts.issueId, path, value, projectId: opts?.projectId });
      resolve(newIssue);
    });
  }
};

export default projectIssueActions;
